import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface SlideOverProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}
export function SlideOver({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer
}: SlideOverProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-183">
      {open && <div className="fixed inset-0 z-50 flex justify-end" data-id="element-184">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="absolute inset-0 bg-slate-900/30 dark:bg-black/50 backdrop-blur-sm" aria-hidden data-id="element-185" />
          <motion.aside role="dialog" aria-modal="true" aria-label={title} initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        stiffness: 380,
        damping: 38
      }} className="relative flex h-full w-full max-w-md flex-col bg-white dark:bg-[#1a1a1a] border-l border-slate-200 dark:border-[#333] shadow-2xl" data-id="element-186">
            <header className="flex items-start justify-between gap-4 border-b border-slate-200 dark:border-[#333] px-6 py-4" data-id="element-187">
              <div data-id="element-188">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white" data-id="element-189">
                  {title}
                </h2>
                {subtitle && <p className="mt-1 text-xs text-slate-500 dark:text-[#a3a3a3]" data-id="element-190">
                    {subtitle}
                  </p>}
              </div>
              <button onClick={onClose} aria-label="Close" className="rounded-lg p-2 text-slate-500 dark:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5 transition-colors" data-id="element-191">
                <X size={18} data-id="element-192" />
              </button>
            </header>
            <div className="flex-1 overflow-y-auto px-6 py-4" data-id="element-193">{children}</div>
            {footer && <footer className="border-t border-slate-200 dark:border-[#333] px-6 py-4" data-id="element-194">
                {footer}
              </footer>}
          </motion.aside>
        </div>}
    </AnimatePresence>;
}